const galleryTrippleAdditionalImgCount = () => {
  if ($('.gallery-tripple').length) {
    if ($('.gallery-tripple__additional').length) {
      $('.gallery-tripple__numbs').addClass('active');
      $('.gallery-tripple__numbs-value').text(
        $('.gallery-tripple__additional').length
      );
    }
  }
};

let trippleGalleryOptions = {
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  adaptiveHeight: true,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: 'unslick',
    },
  ],
};

const trippleGallerySlickOnMobile = () => {
  let res = resolutionCheck();
  $('.gallery-tripple').slick(trippleGalleryOptions);
  if (res < 120) {
    $('.gallery-tripple').slick('refresh');
  }

  var $TGCstatus = $('.gallery-tripple-count');
  var $TGslick = $('.gallery-tripple');

  $TGslick.on(
    'init reInit afterChange refresh resize',
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $TGCstatus.html(
        `<div class="gallery-tripple-count__item">` +
          i +
          `</div><div class="gallery-tripple-count__item">&nbsp;&nbsp;&nbsp;of&nbsp;&nbsp;&nbsp;</div>` +
          `<div class="gallery-tripple-count__item">` +
          slick.slideCount +
          `</div>`
      );
    }
  );
};

$(document).ready(function () {
  galleryTrippleAdditionalImgCount();
  trippleGallerySlickOnMobile();
});

$(window).on('resize orientationchange', function () {
  let resTG = resolutionCheck();
  if (resTG < 120) {
    // $('.gallery-tripple').slick(trippleGalleryOptions);
    if ($('.gallery-tripple').hasClass('slick-initialized')) {
      $('.gallery-tripple').slick('refresh');
    } else {
      $('.gallery-tripple').slick(trippleGalleryOptions);
    }
  } else {
    if ($('.gallery-tripple').hasClass('slick-initialized')) {
      $('.gallery-tripple').slick('unslick');
    }
  }
});
